var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"loading_box"},[_c('div',{staticClass:"loading_mask"}),_vm._v(" "),_c('div',{staticClass:"loading_toast"},[_c('spinner',{attrs:{"type":"android"}}),_vm._v(" "),_c('p',{staticClass:"loading_content"},[_vm._v(_vm._s(_vm.text || '加载中'))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15594f87","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/loading.vue
// module id = j4t3
// module chunks = 15